export function checkRole(obj, roleName) {
  const commonRoleName = roleName.toLowerCase().trim();

  const { user_roles = [] } = obj;

  return user_roles.some(({ role } = {}) => role === commonRoleName);
}
